import { render, staticRenderFns } from "./DepartmentShow.vue?vue&type=template&id=1ac187d2"
import script from "./DepartmentShow.vue?vue&type=script&lang=js"
export * from "./DepartmentShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports